import { DownloadOutlined, TableOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { FC, ReactNode } from 'react';

const { Text } = Typography;

interface ITableToolbarProps {
  title: string;
  iconColor: string;
  exportDisabled: boolean;
  onExport: () => void;
  icon?: ReactNode;
}

const TableToolbar: FC<ITableToolbarProps> = ({
  title,
  iconColor,
  exportDisabled,
  onExport,
  icon,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 12,
    }}
  >
    {icon ?? <TableOutlined style={{ fontSize: 18, color: iconColor }} />}
    <Text strong style={{ color: '#2f3a45' }}>
      {title}
    </Text>
    <div style={{ marginLeft: 'auto' }}>
      <Button
        icon={<DownloadOutlined />}
        size="small"
        disabled={exportDisabled}
        onClick={onExport}
      >
        Export CSV
      </Button>
    </div>
  </div>
);

export default TableToolbar;
